import {connect} from "react-redux";
import {State} from "../reducers";
import HeaderNav from "../components/HeaderNav";

const mapStateToProps = (state: State) => ({
  title: state.products.projectName
});

export default connect(mapStateToProps)(HeaderNav);
